import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {Camera, CameraOptions} from '@ionic-native/camera/ngx';
import {PhotoDTOModel} from '../../models/photoDTO.model';
import {DocumentModel} from '../../models/document.model';
import {ImagePicker, ImagePickerOptions} from '@ionic-native/image-picker/ngx';
import {CustomerLocationDTOModel} from '../../models/customerLocationDTO.model';
import {FindGeoLocationService} from '../../services/find-geo-location.service';
import {ReadBase64Service} from '../../services/read-base64.service';
import {Base64} from '@ionic-native/base64/ngx';
import {Subject} from 'rxjs';

import * as EXIF from 'exif-js/exif';
import {File} from '@ionic-native/file';
import { EditPhotoComponent } from '../edit-photo/edit-photo.component';

@Component({
    selector: 'app-take-picture',
    templateUrl: './take-picture.page.html',
    styleUrls: ['./take-picture.page.scss'],
})
export class TakePicturePage implements OnInit {

    @Input() document: DocumentModel;
    @ViewChild('pwaphotoCamera') pwaphotoCamera: ElementRef;
    @ViewChild('pwaphotoGallery') pwaphotoGallery: ElementRef;

    clickTakePhotoObservable = new Subject<boolean>();
    count = 0;

    private options: CameraOptions = {
        quality: 75,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        saveToPhotoAlbum: false,
        correctOrientation: true
    };

    private galleryOpt: ImagePickerOptions = {
        maximumImagesCount: 5,
        quality: 75,
        outputType: 1
    };

    constructor(private modalController: ModalController,
                private camera: Camera,
                private imagePicker: ImagePicker,
                private findGeoLocation: FindGeoLocationService,
                private readBase64: ReadBase64Service,
                private base64: Base64,
                private platform: Platform) {
    }

    async ngOnInit() {
        if (!this.document.photosURL) {
            this.document.photosURL = new Array<PhotoDTOModel>();
        }
    }

    async takePicture() {
        if ((this.platform.is('android') || this.platform.is('ios'))) {
            const imagePath = await this.camera.getPicture(this.options);
            await this.populatePhotoModelDTO(imagePath, 'camera', null);
        } else {
            this.pwaphotoCamera.nativeElement.click();
        }
    }

    openGallery() {
        this.pwaphotoGallery.nativeElement.click();
        // Leave the legacy method commented out for now
        // if (false) {// window.cordova && this.platform.is('android')) {
        //     try {
        //         this.imagePicker.getPictures(this.galleryOpt).then(results => {
        //             for (const result of results) {
        //                 this.readExifFromMobile(result).then(exif => {
        //                     this.base64.encodeFile(result).then((base64File: string) => {
        //                         console.log('Metadata Result: ');
        //                         console.log(result);
        //                         this.populatePhotoModelDTO(base64File, 'gallery');
        //                     }, (err) => {
        //                         console.log(err);
        //                     });
        //                 });
        //                 // this.readExif(result).then(exif => {
        //                 //     console.log(exif);
        //                 //
        //                 // });
        //             }
        //         }, (err) => {
        //             console.log(err);
        //         });
        //     } catch (e) {
        //         console.log(e);
        //     }
        // } else {
        //     this.pwaphotoGallery.nativeElement.click();
        // }
    }

    async readExif(img) {
        console.log('Type of img: ', typeof img);
        console.log(img);
        return new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            const fileByteArray = [];
            reader.readAsArrayBuffer(img);
            reader.onloadend = function (evt: any) {
                console.log(evt);
                if (evt.target.readyState === FileReader.DONE) {
                    const arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (let i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }
                    const temp = EXIF.readFromBinaryFile(arrayBuffer); // EXIF.readFromBinaryFile(fileReader.readAsArrayBuffer(img));
                    resolve(temp);
                }
            };
        });
    }

    removeImg(imgEntry, position) {
        this.document.photosURL.splice(position, 1);
    }

    async cancelModal() {
        await this.modalController.dismiss(this.document.photosURL);
    }

    captureImagePWA(event) {
        const fileList: FileList = this.pwaphotoCamera.nativeElement.files;
        this.processFileListPWA(fileList);
        console.log(fileList);
    }

    captureGalleryPWA(event) {
        const fileList: FileList = this.pwaphotoGallery.nativeElement.files;
        this.processFileListPWA(fileList);
        console.log(fileList);
    }

    private async processFileListPWA(fileList: any) {
        for (let index = 0; index < fileList.length; index++) {
            const exif = await this.readExif(fileList[index]);
            console.log(exif);
            this.firstFileToBase64(fileList[index]).then((result: string) => {
                this.populatePhotoModelDTO(result, 'gallery', exif);
            }, (err: any) => {
                // Ignore error, do nothing
                console.log(err);
            });
        }
    }

    private firstFileToBase64(fileImage: any): Promise<{}> {
        return new Promise((resolve, reject) => {
            const fileReader: FileReader = new FileReader();
            if (fileReader && fileImage != null) {
                fileReader.readAsDataURL(fileImage);
                fileReader.onload = () => {
                    resolve(fileReader.result);
                };

                fileReader.onerror = (error) => {
                    reject(error);
                };
            } else {
                reject(new Error('No file found'));
            }
        });
    }

    async populatePhotoModelDTO(base64: string, source: string, exif: any) {
        this.initPhotosURL();
        const photoModel = new PhotoDTOModel();
        photoModel.location = new CustomerLocationDTOModel();

        if (source === 'camera') {
            photoModel.photoBase64 = 'data:image/jpeg;base64,' + base64;
        }

        if (source === 'gallery') {
            photoModel.photoBase64 = base64;
        }
        photoModel.filename = this.createFileName();
        photoModel.photoURL = photoModel.filename;
        photoModel.customerRef = this.document.customerRef;

        if (this.document.documentNumber === 0) {
            photoModel.customerRef = this.document.customerRef;
        } else {
            photoModel.customerRef = this.document.documentNumber;
        }
        photoModel.documentNumber = this.document.documentNumber;
        photoModel.documentType = this.document.documentType;
        photoModel.location.id = this.document.location;
        photoModel.documentLocation = this.document.location;
        photoModel.serviceEnquiryWorklistId = this.document.serviceEnquiryWorklistId;
        photoModel.comment = '';

        this.document.photosURL.push(photoModel);

        if (exif) {
            this.processMetaDataFromExif(photoModel, exif);
        }else{
            photoModel.timeStamp = new Date();
        }

        if (source === 'camera' && (this.platform.is('android') || this.platform.is('ios'))) {
            // This code will populate the coordinates in the background allowing the user to see the picture
            await this.populateCoordinates(this.document.photosURL[this.document.photosURL.length - 1]);
        }
        if (this.document.site && photoModel.lat && photoModel.lng) {
            this.document.site.latitude =  photoModel.lat;
            this.document.site.longitude = photoModel.lng;
        }
        console.log(photoModel);
    }

    async populateCoordinates(photoModel: PhotoDTOModel) {
        const currentPosition = await this.findGeoLocation.getCurrentPositionCordova();
        photoModel.lat = currentPosition.latitude;
        photoModel.lng = currentPosition.longitude;
        photoModel.timeStamp = new Date();
    }

    private processMetaDataFromExif(photoModel: PhotoDTOModel, exif: any) {
        if (exif.GPSLatitude && exif.GPSLongitude) {
            let latitudeHelper = exif.GPSLatitude[0] + (( + exif.GPSLatitude[1] + exif.GPSLatitude[2] / 60) / 60);
            if (exif.GPSLatitudeRef === 'S') {
                latitudeHelper *= -1;
            }
            let longitudeHelper = exif.GPSLongitude[0] + (( + exif.GPSLongitude[1] + exif.GPSLongitude[2] / 60) / 60);
            if (exif.GPSLongitudeRef === 'W') {
                longitudeHelper *= -1;
            }
            photoModel.lat = latitudeHelper;
            photoModel.lng = longitudeHelper;
        }

        if (exif.DateTime) {const dateTime = exif.DateTime.split(' ');
            // get date part and replace ':' with '-'
            const dateStr = dateTime[0].replace(/:/g, '-');
            // concat the strings (date and time part)
            const properDateStr = dateStr + ' ' + dateTime[1];
            // pass to Date
            const date = new Date(properDateStr);
            console.log(date);
            photoModel.timeStamp = date;
        }


    }

    createFileName() {
        const d = new Date(),
            n = d.getTime(),
            newFileName = '' + n + '_' + this.document.photosURL.length + '.jpg';
        return newFileName;
    }

    hasReadPermission() {
        if (!this.imagePicker.hasReadPermission) {
            this.requestReadPermission();
        } else {
            return true;
        }
    }

    requestReadPermission() {
        this.imagePicker.requestReadPermission();
    }

    initPhotosURL() {
        if (!this.document.photosURL) {
            this.document.photosURL = new Array<PhotoDTOModel>();
        }
    }

    isAndroid() {
        return this.platform.is('android');

    }

    async handleEditPhoto(e){
        console.log(e);
        //alert('Detected Long Press');
        const modal = await this.modalController.create({
            component: EditPhotoComponent,
            cssClass: 'auto-height',
            componentProps: {
                photoDTO: e
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });

        return await modal.present();
    }
}


